import {colors} from '../defaultSettings';
import {absCenterY} from '@xpertdox_js/xdstyle';

export default {
  container: {
    width: '100%',
    margin: '10px 0 4px',
    position: 'relative',
  },
  contentWrap: {
    position: 'relative',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  content: {
    display: 'inline-block',
    verticalAlign: 'top',
    padding: '6px 0'
  },
  contentRight: {
    paddingRight: '12px',
    transition: 'width .18s ease-out'
  },
  contentLeft: {
    paddingLeft: '12px',
  },
  clearIcon: {
    display: 'block',
    width: '24px',
    height: '24px'
  },
  clearBtn: {
    ...absCenterY,
    padding: 0,
    left: 'auto',
    right: '5px',
    background: 'none',
    fill: '#a1a1a1',
  },
  clearBtnHov: {
    fill: colors.xdDarkBlue,
  },
  searchInput: {
    padding: '5px 22px 5px 8px',
    borderRadius: '150px',
    border: '1px solid rgba(0,0,0,0.2)',
    display: 'block',
    width: '100%'
  },
  form: {
    width: '250px',
    maxWidth: '100%',
    position: 'relative'
  }
}
